import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/district-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/DistrictForm';
import { IDistrict } from 'src/types/district';
import { useDispatch } from 'react-redux';
import { asyncCreateFilesDistrict } from 'src/store/actions/district-actions';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { routes } from '../../../../../../navigation';

export interface StateProps {
    district: IDistrict | null;
    inProgress: boolean;
    files: any;
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getFiles: (id: string | number) => void;

    removeFile: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const DistrictEditScreen: FC<Props> = (props: Props) => {
    const {
        district,
        match: {
            params: { id },
        },
        getFiles,
        files,

        removeFile,
        getData,
        inProgress,
    } = props;
    const dispatch = useDispatch();
    useEffect(() => {
        if (!district || district.id !== id) {
            getData(id);
            getFiles(id);
        }
        // eslint-disable-next-line
    }, [getFiles, getData]);

    const handeAdd = async (files: any) => {
        await asyncCreateFilesDistrict(id, files, dispatch);
    };
    const handeRemove = (fileId: string | number) => {
        removeFile(fileId);
    };

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'DISTRICTS', path: routes.DISTRICTS_LIST },
                    { name: `EDIT ${district?.name}`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                {inProgress ? <Loader /> : !district ? <div></div> : null}
                <Form
                    files={files ? files : []}
                    setFiles={handeAdd}
                    removeFile={(id) => handeRemove(id)}
                    initialValues={{ ...district }}
                />
            </div>
        </AdminLayout>
    );
};

export default DistrictEditScreen;
